<div class="px-4 pb-4">
  @if (countriesSelected.invalid && (countriesSelected.touched || submitted ||
  touched)) {
  <div class="text-danger mb-2">
    <small>{{
      "admin.companyType.validation.atLeastOneCountry" | translate
    }}</small>
  </div>
  }

  <app-grid-table [data]="countries()" [columns]="columns" />

  @if (showButtons()) {
  <div class="d-flex justify-content-end gap-2 px-4 py-4">
    <app-button
      [label]="'general.cancel' | translate"
      variant="default"
      (clicked)="cancel()"
    />
    <app-button
      [iconClass]="'fas fa-save'"
      [label]="'general.save' | translate"
      btnClass="btn btn-primary btn-sm action-btn"
      (clicked)="save()"
      [disabled]="disableSave()"
    />
  </div>
  }
</div>
